export const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';

// Swedish names for the note highlight colors (color1-color5), matching the hues defined
// in $note-colors (_base_variables.scss) – used for accessible names/labels since the
// colors themselves aren't otherwise conveyed to screen reader users.
export const NOTE_COLOR_NAMES: { [color: string]: string } = {
    color1: 'grön',
    color2: 'rosa',
    color3: 'gul',
    color4: 'lila',
    color5: 'grå',
};